import _extends from "@babel/runtime/helpers/esm/extends";
import _objectWithoutProperties from "@babel/runtime/helpers/esm/objectWithoutProperties";
import _classCallCheck from "@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "@babel/runtime/helpers/esm/createClass";
import _possibleConstructorReturn from "@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/esm/getPrototypeOf";
import _assertThisInitialized from "@babel/runtime/helpers/esm/assertThisInitialized";
import _inherits from "@babel/runtime/helpers/esm/inherits";
import _defineProperty from "@babel/runtime/helpers/esm/defineProperty";
import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import { cx } from 'emotion';

var Tag =
/*#__PURE__*/
function (_PureComponent) {
  _inherits(Tag, _PureComponent);

  function Tag() {
    var _getPrototypeOf2;

    var _this;

    _classCallCheck(this, Tag);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _possibleConstructorReturn(this, (_getPrototypeOf2 = _getPrototypeOf(Tag)).call.apply(_getPrototypeOf2, [this].concat(args)));

    _defineProperty(_assertThisInitialized(_this), "handleClick", function () {
      _this.props.onRemoveClick && _this.props.onRemoveClick(_this.props.value);
    });

    return _this;
  }

  _createClass(Tag, [{
    key: "render",
    value: function render() {
      var _this$props = this.props,
          label = _this$props.label,
          value = _this$props.value,
          removable = _this$props.removable,
          onRemoveClick = _this$props.onRemoveClick,
          className = _this$props.className,
          size = _this$props.size,
          rest = _objectWithoutProperties(_this$props, ["label", "value", "removable", "onRemoveClick", "className", "size"]); // eslint-disable-line no-unused-vars


      return React.createElement("span", _extends({
        className: cx('tag', _defineProperty({}, "label-".concat(size), size), className)
      }, rest), label !== undefined ? label : value, removable ? React.createElement("button", {
        className: "close",
        onClick: this.handleClick
      }, "x") : null);
    }
  }]);

  return Tag;
}(PureComponent);

export { Tag as default };
Tag.propTypes = {
  removable: PropTypes.bool,
  onRemoveClick: PropTypes.func,
  label: PropTypes.node,
  value: PropTypes.node,
  size: PropTypes.oneOf(['sm', 'lg']),
  className: PropTypes.string
};
Tag.defaultProps = {
  removable: false
};